import React, {Component} from 'react'
import parse from 'html-react-parser'
import Fade from "react-reveal/Fade";

class BasicPage extends Component {

  render() {

    let {title, content} = this.props

    return (
      <section className={`basic-page`}>
        <div className='basic-page__inner'>
          <div className='basic-page__content'>
            {title && <h1>{parse(title)}</h1>}
            {content && <div>{parse(content)}</div>}
          </div>
        </div>
      </section>
    )
  }
}

export default BasicPage